// Temporary feature for a single pilot cohort - will be killed or rewritten.
// Mounted once app-wide (mirrors ActivityTrackerGate) so the daily check-in prompt
// can fire on any page, not just classroom-specific ones.

import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthProvider';
import useDailyClassmatesCheck from '../hooks/useDailyClassmatesCheck';
import { GroupWorkCheckInModal } from './GroupWorkCheckInModal';

export function GroupWorkCheckInGate() {
  const user = useContext(AuthContext);
  const { shouldShowModal, dismiss, classmates } = useDailyClassmatesCheck(
    user?.is_authenticated ? user.roles : undefined,
  );

  if (!shouldShowModal) return null;

  return (
    <GroupWorkCheckInModal isOpen={shouldShowModal} onClose={dismiss} classmates={classmates} />
  );
}
